import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CookieConsentModalComponent } from './components/cookie-consent-modal/cookie-consent-modal.component';
import { CookiePolicyPageComponent } from './components/cookie-policy-page/cookie-policy-page.component';

@NgModule({
    declarations: [CookieConsentModalComponent, CookiePolicyPageComponent],
    imports: [CommonModule, TranslateModule],
    exports: [CookieConsentModalComponent, CookiePolicyPageComponent]
})
export class CookieConsentModule {}
